const pageMetas = {
	// Personal
	'/car-subscription': {
		title: 'Car Subscription Australia - Flexible, All-Inclusive Service | carbar Australia',
		description:
			'Forget financing, insurance, rego & all the other variable costs of running a car. With a carbar subscription, we take care of that for you. No commitments.',
		image: 'OG-car-subscription-1200x630.png',
		keywords: 'car subscription, flexible driving, carbar',
	},
	'/electric-vehicles': {
		title: 'Subscribe, Finance or Buy Electric Cars | carbar Australia',
		description:
			'Imagine never buying fuel again! With an electric car, that could be a reality. With carbar, you can subscribe, finance or buy an EV online. Make the switch today.',
		image: 'OG-electric-car-subscription-1200x630.png',
		keywords: 'electric vehicles, EV subscription, carbar',
	},
	'/compare-car-subscriptions-vs-leasing': {
		title: 'Compare Car Subscriptions vs. Leasing | carbar Australia',
		description:
			'Car subscription services are very different to car leases. Want more flexibility & less stress? Find out why more & more people are choosing to subscribe.',
		image: 'OG-compare-subs-lease-1200x630.png',
		keywords:
			'comparison, subscription vs leasing, car subscription, car leasing, carbar',
	},
	'/sell-my-car': {
		title: 'Selling Your Car? Get an Instant Valuation Online | carbar Australia',
		description:
			'It has never been easier to sell a car with carbar. Enter a few simple details online to receive an instant valuation. Find out how to sell your car, the easy way!',
		image: 'OG-sell-my-car-1200x630.png',
		keywords:
			'selling your car, selling my car, sell a car, how to sell your car, selling a car online, vehicle transfer, number plates, car insurance, sale price',
	},
	'/car-rent-to-own': {
		title: 'Rent to Own Cars Australia | Smarter Alternative with carbar',
		description: `Explore rent-to-own cars in Australia. Compare costs and risks, and see why carbar's flexible car subscription is the better choice for drivers.`,
		image: 'OG-rent-to-own-cars-1200x630.png',
		keywords:
			'rent to own cars, rent to own cars australia, rent to buy cars, rent to own vs car subscription',
	},
	'/car-lease': {
		title: 'Car Lease in Australia | Leasing vs Subscription with carbar',
		description: `Looking at car leasing? Compare lease costs, limits and terms with carbar's car subscription - flexible, all-inclusive and no long-term lock-ins.`,
		image: 'OG-car-lease-1200x630.png',
		keywords:
			'car lease, car lease australia, car leasing deals, flexible car lease options',
	},
	'/car-long-term-rental': {
		title: 'Long Term Car Rental Australia | Flexible Alternative with carbar',
		description: `Searching for long-term car rental? Carbar's car subscription offers flexible monthly terms, insurance and servicing - a smarter rental alternative.`,
		image: 'OG-long-term-car-rental-1200x630.png',
		keywords:
			'long term car rental, long term car rental australia, cheap long term car hire, monthly car rental australia, long term car rental vs subscription',
	},

	// Business
	'/business': {
		title: 'Elevate Your Business with Novated Leasing and Subscription Solutions | carbar Australia',
		description: `Subscription services are a cost-effective alternative to traditional car ownership & fleet car leasing. We'll bring the fleet cars, you bring the parking spaces!`,
		image: 'OG-business-1200x630.png',
		keywords:
			'business car subscription, business vehicle lease, car subscription, long term, car ownership, new car, weekly payment',
	},
	'/business/novated-subscription': {
		title: 'Novated Subscription | carbar Australia',
		description:
			'Drive smarter business: Explore the benefits of novated subscription',
		image: 'OG-novated-subs-1200x630.png',
		keywords: 'novated lease, novated subscription, carbar',
	},
	'/business/novated-lease': {
		title: 'Novated Lease | carbar Australia',
		description:
			'Drive smarter business: Explore the benefits of novated leases',
		image: 'OG-novated-lease-1200x630.png',
		keywords: 'novated lease, novated leasing, carbar',
	},
	'/business/novated-ev-subscription': {
		title: 'Novated EV Subscription: Unlock the Perks | carbar Australia',
		description: `Discover novated EV subscriptions: flexible, tax-effective, and cost-saving employee benefits. Say goodbye to traditional novated leases. See how it works!`,
		image: 'OG-novated-ev-subscription-1200x630.png',
		keywords:
			'novated electric vehicle subscription, novated EV subscription, carbar',
	},
	'/business/fleet-subscription': {
		title: 'Business Car Fleet Subscriptions of All Sizes | carbar Australia',
		description:
			'Enjoy the benefits of traditional car ownership without the long term commitment. Whether a single vehicle or fleet, carbar has a business subscription for you!',
		image: 'OG-business-fleet-subscription-1200x630.png',
		keywords:
			'business car subscription, business vehicle lease, car subscription, long term, car ownership, new car, weekly payment',
	},
	'/business/fleet-subscription/small-business': {
		title: 'Flexible Car Subscription for Small Business | carbar Australia',
		description:
			'The costs of traditional car ownership & business car leases can be demanding for small businesses. Manage costs with a carbar flexible car subscription.',
		image: 'OG-business-fleet-subscription-1200x630.png',
		keywords:
			'small business fleet subscription, small business car subscription, carbar',
	},
	'/business/tools-of-trade/employee-benefits': {
		title: 'Employee Benefits | carbar Australia',
		description:
			'Empower your team with the tools they need. Save big on taxes - the ultimate employee benefit.',
		image: 'OG-employee-benefits-1200x630.png',
		keywords:
			'tools of trade, employee benefits, car subscription, car leasing, carbar',
	},

	// Others
	'/buying-a-car/buying-a-new-car': {
		title: 'Compare Deals & Buy a New Car Online | carbar Australia',
		description: `Buying a new car doesn't have to be stressful. Forget car yards. Shop online for the best new car deals in Australia. Buy a new car for the best price possible!`,
		image: 'OG-buying-car-1200x630.png',
		keywords:
			'buying a new car, new car buying, car subscription, car leasing, carbar',
	},
	'/car-subscription/fees-and-charges': {
		title: 'View our Fees and Charges | carbar Australia',
		description:
			'carbar is a research, communications and eCommerce platform, as well as a licenced dealer in QLD, NSW & VIC. View all fees and charges here.',
		image: 'OG-fees-charges-1200x630.png',
		keywords: 'car subscription fees, car subscription charges, carbar',
	},
	'/about-us': {
		title: 'Everything You Need to Know About carbar | carbar Australia',
		description:
			'carbar is transforming the way you buy & own cars. Find out more about carbar Australia, the company that lets you buy, sell, finance or subscribe to cars online.',
		image: 'OG-about-us-1200x630.png',
		keywords: 'car subscription fees, car subscription charges, carbar',
	},
	'/about-us/careers': {
		title: 'Find Out More About Careers at carbar | carbar Australia',
		description:
			'Want to know why you should work for carbar? Check out what makes carbar the best place to work, find out about our employee benefits & view open roles!',
		image: 'OG-careers-1200x630.png',
		keywords: 'career, car subscription service, digital-led, carbar',
	},
	'/car-finance': {
		title: 'Compare & Apply for Car Finance Online | carbar Australia',
		description:
			'carbar gives you access to some of the most reputable car finance lenders in Australia. Calculate repayments, get expert help & apply online. Learn how.',
		image: 'OG-car-finance-1200x630.png',
		keywords:
			'car finance, car loan, used car loan, business car loan, carbar',
	},
	'/dealers': {
		title: 'Car Subscription for Dealers - carbar.com.au | carbar Australia',
		description:
			'Forget financing, insurance, rego & all the other variable costs of running a car. With a carbar subscription, we take care of that for you. No commitments.',
		image: 'OG-dealers-1200x630.png',
		keywords:
			'car subscription made easy, partner with carbar, partnership, carbar',
	},
	'/press': {
		title: 'Read About carbar in the News and Media | carbar Australia',
		description:
			'Find out about carbar in the news and media. Read our latest press releases or find out how to contact us for press enquiries.',
		keywords: 'news, media, press release, press enquiries, carbar',
	},

	// Partners - Greener for Business
	'/partners/greener-for-business': {
		title: 'Greener for Business | carbar Australia',
		description:
			'Discover novated EV subscriptions: flexible, tax-effective, and cost-saving employee benefits. Say goodbye to traditional novated leases. See how it works!',
		image: 'OG-partner-greener-for-business-1200x630.png',
		keywords:
			'Greener for Business, car subscription, electric vehicles, car leasing, carbar',
	},

	// Radio
	'/radio': {
		title: '89.9 LightFM | carbar Australia',
		description: `At carbar, we're all about making life easier and with LightFM. Share our values of simplicity, connection and positivity.`,
		image: 'OG-partner-lightfm-1200x630.png',
		keywords:
			'LightFM, 89.9 the light, car subscription, Driving Hope Together, car leasing, carbar',
	},

	// Promotions
	'/promotion/auroraenergy/get-electrified': {
		title: 'Get Electrified | carbar Australia',
		description: `Get Electrified with carbar and Aurora Energy`,
		image: 'OG-promotion-get-electrified-1200x630.png',
		keywords:
			'Aurora Energy, Get Electrified, car subscription, electric vehicles, car leasing, carbar',
	},

	// Cities
	'/brisbane': {
		title: 'Subscribe or Buy Your Next Car in Brisbane | carbar Australia',
		description:
			'Looking to buy, sell, subscribe or finance your next car? You can do it online with carbar and collect it from our Brisbane office.',
		keywords:
			'used cars in brisbane, cars for sale brisbane, car sales brisbane, brisbane used cars, brisbane cars, body type, used cars, new cars, brisbane qld, used car',
	},
	'/melbourne': {
		title: 'Cars Available in Melbourne to Subscribe or Buy | carbar Australia',
		description:
			'Looking to buy, sell, subscribe or finance your next car? You can do it online with carbar and collect it from our Melbourne office.',
		keywords:
			'used cars in melbourne, cars for sale melbourne, car sales melbourne, melbourne used cars, melbourne cars, body type, used cars, new cars, melbourne vic, used car',
	},
	'/sydney': {
		title: 'Subscribe or Buy Your Next Car in Sydney | carbar Australia',
		description:
			'With carbar, you can buy, sell, subscribe or finance your next car totally online and collect it from our Sydney office.',
		keywords:
			'used cars in sydney, cars for sale sydney, car sales sydney, sydney used cars, sydney cars, body type, used cars, new cars, sydney nsw, used car',
	},

	// Home
	'/': {
		title: 'Car Subscription | carbar Australia',
		description:
			'Forget financing, insurance, rego & all the other variable costs of running a car. With a carbar subscription, we take care of that for you. No commitments.',
		image: 'OG-home-1200x630.png',
		keywords:
			'car subscription, group subscription, car leasing, car finance, car buying, car selling',
	},
}

const pageMetasCarsales = {
	'/partners/carsales': {
		title: 'Driving Made Simple | carbar Australia referred by carsales',
		description:
			'carsales is referring carbar to give you more options to get you on the road. Car subscription offers a flexible alternative to buying, with no long term commitment.',
		image: 'OG-carsales-1200x630.png',
	},
	'/partners/carsales/group-subscription': {
		title: 'Group Subscription | carbar Australia referred by carsales',
		description: 'A community-powered way to subscribe for less.',
		keywords:
			'group subsription, car subscription, community-powered, significantly cheaper',
		image: 'OG-carsales-1200x630.png',
	},
	'/partners/carsales/how-it-works': {
		title: 'How Car Subscription Works | carbar Australia referred by carsales',
		description:
			'carsales is referring carbar to give you more options to get you on the road. Car subscription offers a flexible alternative to buying, with no long term commitment.',
		image: 'OG-carsales-1200x630.png',
	},
	'/partners/carsales/about-us': {
		title: 'About Car Subscription | carbar Australia referred by carsales',
		description:
			'carsales is referring carbar to give you more options to get you on the road. Car subscription offers a flexible alternative to buying, with no long term commitment.',
		image: 'OG-carsales-1200x630.png',
	},
}

const pageMetasErinLiving = {
	'/partners/erinliving': {
		title: 'Exclusive Car Subscription Offer in Your Community - Erin Living | carbar Australia',
		description:
			'Discounted access for all residents in Erin Living buildings.',
		image: 'OG-erinliving-1200x630.png',
	},
	'/partners/erinliving/how-it-works': {
		title: 'How Car Subscription Works - Erin Living | carbar Australia',
		description:
			'Discounted access for all residents in Erin Living buildings.',
		image: 'OG-erinliving-1200x630.png',
	},
	'/partners/erinliving/about-us': {
		title: 'About Car Subscription - Erin Living | carbar Australia',
		description:
			'Discounted access for all residents in Erin Living buildings.',
		image: 'OG-erinliving-1200x630.png',
	},
}

export const siteMeta = (pagePath) => {
	const { partnerName } = useGetPartnerName()

	let meta = ''

	switch (partnerName.value) {
		case 'carsales':
			meta = pageMetasCarsales[pagePath]
			break
		case 'erinliving':
			meta = pageMetasErinLiving[pagePath]
			break

		default:
			meta = pageMetas[pagePath]
			break
	}

	let imagePath

	// Set default OG image for /cars/subscribe and its filtered subroutes.
	// Note: individual vehicle pages will override this with their own image.
	if (pagePath.startsWith('/cars/subscribe')) {
		imagePath = 'OG-car-subscription-1200x630.png'
	} else if (pagePath.startsWith('/partners/carsales/browse')) {
		imagePath = 'OG-carsales-1200x630.png'
	} else if (pagePath.startsWith('/partners/erinliving/browse')) {
		imagePath = 'OG-carsales-1200x630.png'
	} else {
		imagePath = meta?.image
	}

	const runtimeConfig = useRuntimeConfig()

	return {
		type: 'website',
		title: meta?.title ? meta.title : runtimeConfig.public.SITE_NAME,
		description: meta?.description
			? meta.description
			: runtimeConfig.public.SITE_DESCRIPTION,
		keywords: meta?.keywords ? meta.keywords : '',
		image: `${runtimeConfig.public.APP_URL}/_ipx/q_100/img/seo-meta/${imagePath || runtimeConfig.public.SITE_IMAGE}`,
		imageWidth: 1200,
		imageHeight: 630,
		locale: 'en-AU',
		url: `${runtimeConfig.public.APP_URL || 'https://www.carbar.com.au'}${pagePath}`,
	}
}
